import styled from "styled-components";
import { breakpoints } from "../../../../../../shared-logic/themes/lexusTheme";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-2);
    margin-inline: calc(var(--spacing-2) * -1);
    padding-inline: var(--spacing-2);
    background-color: var(--color-mist);
    padding-block: var(--spacing-3);

    @media screen and (min-width: ${breakpoints.md}) {
        margin-inline: calc(var(--spacing-3) * -1);
        padding-inline: var(--spacing-3);
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        margin-inline: 0;
        padding-inline: 0;
        padding-block: 0;
        background-color: transparent;
    }

    @supports not (padding-inline: 0) {
        & > div:not(:nth-last-child(1)) {
            margin-bottom: var(--spacing-2);
        }
    }
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    column-gap: var(--spacing-3);
`;

export const VehicleInfo = styled.div`
    margin-top: 2px;
    margin-bottom: var(--spacing-1);
    font-size: 1.3rem;
    line-height: 1;

    /* Show long texts inside proper on multiple lines */
    & > span {
        display: inline;

        &:not(:nth-last-child(1)) {
            margin-inline-end: var(--spacing-1);
        }
    }

    @supports not (padding-inline: 0) {
        & > span {
            &:not(:nth-last-child(1)) {
                margin-right: var(--spacing-1);
            }
        }
    }
`;

export const VehicleDealerCityIcon = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const VehicleDealerCity = styled.div`
    display: flex;
    column-gap: 6px;

    @supports not (padding-inline: 0) {
        svg {
            margin-right: var(--spacing-1);
        }
    }
`;

export const ButtonCtaWrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-1);

    & > button {
        &:not(:only-child) {
            flex-basis: 50%;
        }
    }

    & > div {
        flex: 0 0 100%;
    }

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        column-gap: var(--spacing-3);
        row-gap: 0;

        & > div {
            flex: 0 0 50%;
        }
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        column-gap: var(--spacing-2);
    }

    @supports not (padding-inline: 0) {
        & > button:not(:nth-last-child(1)) {
            margin-right: var(--spacing-2);
        }
    }
`;

export const VehicleCodeWrapper = styled.div`
    @media screen and (min-width: ${breakpoints.lg}) {
        display: none;
    }
`;
